
export const BRAND_RED = "#BC3F4A";
export const BRAND_RED_DARK = "#a33441";
export const BRAND_BG = "#f5f3ea";

export const PARTICLE_COUNT = 32;
export const GRADIENT_BAR =
  "absolute left-0 right-0 h-[3px] bg-gradient-to-r from-transparent via-[#BC3F4A]/40 to-transparent";

export const labelCls =
  "text-[10px] uppercase tracking-[0.22em] text-stone-400 font-sourcesans";
export const bodyCls = "font-sourcesans text-base text-stone-500 leading-[1.8]";
export const ctaBase =
  "inline-block text-xs uppercase tracking-[0.18em] px-5 py-3 font-sourcesans transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#BC3F4A]";




export const PRODUCT_CATEGORIES = [
  "Art For Ukraine",
  "Fine Art Prints",
  "String Art For Ukraine",
  "Fine Art For Ukraine",
  "String Art",
  "Used Books",
];

export const BLOG_CATEGORIES = [
  "Faith & Reflection",
  "Photography & Art",
  "Movement & Discipline",
  "Tech & Learning",
  "Kitchen & Table",
  "Stories & Adventures",
];

export const categoryLabels = {
  "Used Books": {
    details: "Book Details",
    ecoFeatures: "Eco-friendly Features",
    usageTips: "Reading Tips",
  },
  "Fine Art Prints": {
    details: "Print Details",
    ecoFeatures: "Sustainable Practices",
    usageTips: "Display & Care",
  },
  "String Art": {
    details: "Artwork Details",
    ecoFeatures: "Eco-friendly Materials",
    usageTips: "Care & Display",
  },
  "Art For Ukraine": {
    details: "Artwork Details",
    ecoFeatures: "Eco-friendly Materials",
    usageTips: "Care & Display",
  },
};
